export const CustomizationRoutes = [
  {
    path: "customization",
    name: "customization",
    component: () => import("@/domain/Customization/views/CustomizationPage.vue"),
    meta: { requiresAuth: true, permissions: "customizations.read" },
  },
];
